module.exports = __webpack_public_path__ + "static/media/link_deleat.c767f717.svg";